/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import TitleAndPagination from "../components/Pagination";
import Table from "../components/CommonTable";
import TopBar from "../components/TopBar";
import { useMediaQuery } from "react-responsive";
import { useEffect } from "react";
import { useState } from "react";
import { useSelector } from "react-redux";
import { getFavourites } from "../services/btc-api.service";
export default function Favoutites() {

  const isMobile = useMediaQuery({ query: '(max-width: 768px)' })
  const [limit, setLimit] = useState(20)
  const [offset, setOffSet] = useState(0)
  const [favourties, setFavourties] = useState()
  const [totalRecords, setTotalRecords] = useState()
  const user = useSelector((state) => state.user.user);

  useEffect(() => {
    if (user && user._id) {
      getData()
    }
  }, [user, limit, offset])

  const getData = async () => {

    const data = await getFavourites(limit, offset, user && user._id ? user._id : undefined);
    
    setFavourties(data.records)
    setTotalRecords(data.totalRecords)
  }
  const handleLimit = (e) => {
    setLimit(e)
  }
  const handlePageChange = (e) => {
    setOffSet(e)
  }
  return (
    <>
      <TopBar />
      <div className="auction-page  container-fluid" >
        <TitleAndPagination handlePageChange={handlePageChange} handleLimit={handleLimit} title={'Favorites'} totalRecords={totalRecords} limit={limit} />
        {favourties && favourties.length > 0 && <Table rows={favourties} isMobile={isMobile} style={{ paddingLeft: isMobile ? 10 : 40, marginTop: 50 }} rowColor />}
      </div>
    </>
  );
}




